export class ReportProjectCommand {
    projectId: string;
    reason: string;
    constructor(projectId: string, reason: string) {
        this.projectId = projectId;
        this.reason = reason;
    }
}
